/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * PerformanceMonitoringApi - interface
 * 
 * @export
 * @interface PerformanceMonitoringApiInterface
 */
export interface PerformanceMonitoringApiInterface {
    /**
     * Establishes a performance baseline for future improvement calculations. This should be called after the system has been running for a while.
     * @summary Establish performance baseline
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PerformanceMonitoringApiInterface
     */
    establishBaselineRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Establishes a performance baseline for future improvement calculations. This should be called after the system has been running for a while.
     * Establish performance baseline
     */
    establishBaseline(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves real-time performance metrics including request counts, database context calls, cache hit ratios, and performance improvements.
     * @summary Get current performance metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PerformanceMonitoringApiInterface
     */
    getCurrentMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves real-time performance metrics including request counts, database context calls, cache hit ratios, and performance improvements.
     * Get current performance metrics
     */
    getCurrentMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves comprehensive performance dashboard data including metrics, improvements, and trends for real-time monitoring.
     * @summary Get performance dashboard data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PerformanceMonitoringApiInterface
     */
    getDashboardDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves comprehensive performance dashboard data including metrics, improvements, and trends for real-time monitoring.
     * Get performance dashboard data
     */
    getDashboardData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the current performance health status including key performance indicators and system health metrics.
     * @summary Get performance health status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PerformanceMonitoringApiInterface
     */
    getHealthStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the current performance health status including key performance indicators and system health metrics.
     * Get performance health status
     */
    getHealthStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves a summary of performance improvements including context call reductions, time savings, and cache hit ratios.
     * @summary Get performance improvement summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PerformanceMonitoringApiInterface
     */
    getImprovementSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves a summary of performance improvements including context call reductions, time savings, and cache hit ratios.
     * Get performance improvement summary
     */
    getImprovementSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Resets all performance metrics to zero. Useful for testing or establishing new performance baselines.
     * @summary Reset performance metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PerformanceMonitoringApiInterface
     */
    resetMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Resets all performance metrics to zero. Useful for testing or establishing new performance baselines.
     * Reset performance metrics
     */
    resetMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class PerformanceMonitoringApi extends runtime.BaseAPI implements PerformanceMonitoringApiInterface {

    /**
     * Establishes a performance baseline for future improvement calculations. This should be called after the system has been running for a while.
     * Establish performance baseline
     */
    async establishBaselineRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/performance/baseline`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Establishes a performance baseline for future improvement calculations. This should be called after the system has been running for a while.
     * Establish performance baseline
     */
    async establishBaseline(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.establishBaselineRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves real-time performance metrics including request counts, database context calls, cache hit ratios, and performance improvements.
     * Get current performance metrics
     */
    async getCurrentMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/performance/metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves real-time performance metrics including request counts, database context calls, cache hit ratios, and performance improvements.
     * Get current performance metrics
     */
    async getCurrentMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCurrentMetricsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves comprehensive performance dashboard data including metrics, improvements, and trends for real-time monitoring.
     * Get performance dashboard data
     */
    async getDashboardDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/performance/dashboard`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves comprehensive performance dashboard data including metrics, improvements, and trends for real-time monitoring.
     * Get performance dashboard data
     */
    async getDashboardData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getDashboardDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current performance health status including key performance indicators and system health metrics.
     * Get performance health status
     */
    async getHealthStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/performance/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the current performance health status including key performance indicators and system health metrics.
     * Get performance health status
     */
    async getHealthStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getHealthStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a summary of performance improvements including context call reductions, time savings, and cache hit ratios.
     * Get performance improvement summary
     */
    async getImprovementSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/performance/improvements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves a summary of performance improvements including context call reductions, time savings, and cache hit ratios.
     * Get performance improvement summary
     */
    async getImprovementSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getImprovementSummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resets all performance metrics to zero. Useful for testing or establishing new performance baselines.
     * Reset performance metrics
     */
    async resetMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/performance/reset`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Resets all performance metrics to zero. Useful for testing or establishing new performance baselines.
     * Reset performance metrics
     */
    async resetMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resetMetricsRaw(initOverrides);
        return await response.value();
    }

}
